<template>
	<div :class="rctype == 1?'':'gttcard'" style="margin-bottom: 24px;">
		<!-- <p v-if="rctype == 0" class='gttcard-tt'>播报记录</p> -->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane :label="$t('terminal.broadcast_record')" name="one">
				<div class="gttcard-in">
					<el-row :gutter="20">
						<el-col :span="3">
							<el-button @click="output" size="small" type="primary">{{ $t('terminal.export_records') }}</el-button>
						</el-col>
						<el-col :span="5">
							<div class="glineflex" v-if="ctype == 0">
								<label class="glinelb">{{ $t('terminal.serial_number') }}：</label>
								<el-input @keyup.enter.native="srcList" v-model="order" size="small" :placeholder="$t('terminal.serial_number')">
								</el-input>
							</div>
							<div class="glineflex" v-else>
								<label class="glinelb">{{ $t('terminal.branch_store') }}：</label>
								<Bstore :config="bconfig"></Bstore>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="glineflex">
								<label class="glinelb">{{ $t('terminal.broadcast_state') }}：</label>
								<el-select size="small" v-model="pstatus" clearable style="width: 100%;"
									:placeholder="$t('app_select')" @change="srcList">
									<el-option v-for="(item,index) in $playSts" :key="index" :label="item.lb"
										:value="item.vl"></el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="10">
							<div class="glineflex">
								<label class="glinelb">{{ $t('terminal.date_filter') }}：</label>
								<el-date-picker style="width: 100%;" size="small" @change="srcList" v-model="pkdate"
									value-format="yyyy-MM-dd" type="daterange" range-separator="~"
									:start-placeholder="$t('app_start_time')" :end-placeholder="$t('app_end_time')"></el-date-picker>
							</div>
						</el-col>
					</el-row>
					<el-table class="gtbtop" tooltip-effect="dark" :data="tableData" style="width: 100%">
						<el-table-column v-if="ctype == 1" prop="deviceId" :label="$t('terminal.device_no')" width></el-table-column>
						<el-table-column prop="amount" :label="$t('terminal.app_amount')" width :formatter="symbol"></el-table-column>
						<el-table-column prop="status" :label="$t('terminal.broadcast_state')" :formatter="setPS" width='90'></el-table-column>
						<el-table-column prop="template" :label="$t('terminal.broadcast_template')"></el-table-column>
						<el-table-column v-if="ctype == 1" prop="referenceid" :label="$t('terminal.serial_number')" width></el-table-column>
						<el-table-column v-else prop="traceid" :label="$t('terminal.serial_number')" width></el-table-column>
						<!-- <el-table-column
              prop="terminalStatus"
              label="交易时间"        
              width="">
              <template slot-scope="scope">
                <div v-if='scope.row.terminalStatus == 0' class='eqbs-ball-gray'></div>
                <div v-else class='eqbs-ball-green'></div>
                &nbsp;<label>{{$eqBindSt[scope.row.terminalStatus + '']}}</label>
              </template>
            </el-table-column>-->
						<el-table-column prop="requesttime" :label="$t('terminal.broadcast_time')" width='175'></el-table-column>
						<el-table-column prop="responsetime" :label="$t('terminal.response_time')" width='175'>
						</el-table-column>
						<el-table-column prop="responsetime" :label="$t('terminal.broadcast_time_consuming')" width='125'>
							<template scope="scope">
								{{scope.row.timeTaken + $t('app_millisecond')}}
							</template>
						</el-table-column>
					</el-table>
					<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>
				</div>
			</el-tab-pane>
			<el-tab-pane :label="$t('terminal.online_offline_records')" name="two">
				<div class="gttcard-in">
					<el-row>
						<el-col :span="24">
							<el-button @click='exportRc' type='primary' size="small">{{ $t('terminal.export_records') }}</el-button>
						</el-col>
					</el-row>
					<el-table class="gtbtop" tooltip-effect="dark" :data="tableData1" style="width: 100%">
						<!-- <el-table-column prop="deviceId" label="设备SN" width></el-table-column>
            <el-table-column prop="productKey" label="产品Key"></el-table-column>
            <el-table-column prop="context" label="内容"></el-table-column>
            <el-table-column prop="status" label="状态" :formatter="setLinest" width></el-table-column>                     
            <el-table-column prop="createTime" label="时间" width></el-table-column> -->
						<el-table-column prop="deviceId" :label="$t('terminal.device_sn')" width="150"></el-table-column>
						<!-- <el-table-column prop="productKey" label="产品Key" width="110"></el-table-column> -->
						<el-table-column prop="context" :label="$t('app_content')"></el-table-column>
						<el-table-column prop="status" :label="$t('app_status')" :formatter="setLinest" width="150"></el-table-column>
						<el-table-column prop="createTime" :label="$t('app_time')"  width="170"></el-table-column>
					</el-table>
					<Pages class="gpages" :cpage="page1" :ctotal="total1" :config="pconfig1"></Pages>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import Pages from "@/components/Pages.vue";
	import Bstore from "@/components/Bstore.vue";
	export default {
		data() {
			return {
				activeName: "one",
				order: "",
				ptype: "",
				pstatus: "",
				total: 0,
				total1: 0,
				page: 1,
				page1: 1,
				pconfig: "",
				pconfig1: "",
				tableData: [],
				tableData1: [],
				pkdate: [],
				mcid: "",
				dvid: "",
				stid: "",
				ctype: "0", //// 0 equip 1 bcstore
				bconfig: {}
			};
		},
		components: {
			Pages,
			Bstore
		},
		props: ["ctotal", "config"],
		computed: {
			rctype() {
				return this.ctype;
			}
		},
		watch: {
			config(cf) {
				var _this = this;
				this.dvid = cf.dvid ? cf.dvid : "";
				this.mcid = cf.mcid ? cf.mcid : "";
				// this.stid = cf.storeid?cf.storeid:''
				this.ctype = cf.ctype;
				this.pconfig = {
					callback: page => {
						///
						_this.page = page;
						_this.getList();
					}
				};
				this.pconfig1 = {
					callback: page => {
						///
						_this.page1 = page;
						_this.getList1();
					}
				};
				this.bconfig = {
					size: "small",
					mcid: this.mcid,
					callback: vl => {
						_this.stid = vl ? vl : "";
						_this.getList();
					}
				};
				this.getList();
				this.getList1();
			}
		},
		methods: {
			exportRc() {
				this.$exportOOLineRecord(this.dvid)
			},
			handleClick(tab, ev) {},
			setPS(row) {
				var vl = this.$playSt[row.status];
				return vl ? vl : row.status;
				// return row.status
			},
			setLinest(row) {
				return this.$dvOFSt[row.status];
			},
			output() {
				var deviceid = this.dvid;
				var merchantId = this.mcid;

				var stime = "";
				var etime = "";
				if (this.pkdate) {
					stime = this.pkdate.length > 0 ? this.pkdate[0] : "";
					etime = this.pkdate.length > 1 ? this.pkdate[1] : "";
				}
				if (this.ctype == 0) {
					this.$outputRcRecord(
						deviceid,
						this.order,
						this.ptype,
						this.pstatus,
						merchantId,
						stime,
						etime
					);
				} else {
					this.$outputBCSRecord(this.stid, this.mcid, this.pstatus, stime, etime);
				}
			},
			srcList() {
				this.page = 1;
				this.getList();
			},
			getList() {
				this.loading = true;
				var deviceid = this.dvid;
				var merchantId = this.mcid;
				var stime = "";
				var etime = "";
				if (this.pkdate) {
					stime = this.pkdate.length > 0 ? this.pkdate[0] : "";
					etime = this.pkdate.length > 1 ? this.pkdate[1] : "";
				}
				if (this.ctype == 0) {
					this.$equipLogpay(
						this.page,
						this.$gRow,
						deviceid,
						this.order,
						this.ptype,
						this.pstatus,
						merchantId,
						stime,
						etime,
						res => {
							this.loading = false;
							if (res.status == 200) {
								//console.log('receip: '+ JSON.stringify(res.data))
								this.total = res.total;
								this.tableData = res.data;
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				} else {
					this.$bcstPlayRc(
						this.page,
						this.$gRow,
						this.stid,
						merchantId,
						this.pstatus,
						stime,
						etime,
						res => {
							this.loading = false;
							if (res.status == 200) {
								this.total = res.total;
								this.tableData = res.data;
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				}
			},
			getList1() {
				this.loading = true;
				// var deviceid = this.dvid;      
				var status = ''
				this.$dvOFList(this.page1, this.$gRow, this.dvid, status, res => {
						this.loading = false;
						if (res.status == 200) {
							this.total1 = res.total;
							this.tableData1 = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			symbol(row, column) {
				return "¥" + row.amount;
			}
		},
		mounted() {

			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getList();
				}
			};
			this.pconfig1 = {
				callback: page => {
					///
					_this.page1 = page;
					_this.getList1();
				}
			};
			// this.getList()
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
